import Map from '../plugins/PluginMap.ts' // if use on templates page
//import Map from '../plugins/PluginMap.ts'; // if you want to use on a project

declare const markers: any

window.addEventListener('load', () => {
  // Init map
  const mapContainer =
    document.querySelectorAll<HTMLElement>("[data-item='map']")
  if (mapContainer.length > 0) {
    mapContainer.forEach((container: HTMLElement) => {
      const map = new Map(container, {
        openInPopup: false,
        accessToken: container.dataset.token,
        centerLatitude: container.dataset.lat as string,
        centerLongitude: container.dataset.lng as string,
        coordinates: markers,
      })
    })
  }

  const mapContainerContact = document.querySelectorAll<HTMLElement>(
    "[data-item='map-contact']",
  )
  if (mapContainerContact.length > 0) {
    mapContainerContact.forEach((container: HTMLElement) => {
      const map = new Map(container, {
        openInPopup: false,
        accessToken: container.dataset.token,
        centerLatitude: container.dataset.lat as string,
        centerLongitude: container.dataset.lng as string,
        zoom: 14,
        coordinates: markers,
      })
    })
  }
})
